<template>
  <div :class="getClassName('modal')" v-if="visible">
    <div :class="getClassName('modal__overlay')" @click="hideModal"></div>
    <div :class="getClassName('modal__wrapper')">
      <button class="modal__close--upper" type="button" @click="hideModal">
        <span class="modal__cross--white" />
      </button>
      <div :class="getClassName('modal__content')">
        <v-img :class="getClassName('modal__image')" :src="content" alt="" v-if="content" />

        <button class="modal__close" type="button" @click="hideModal" v-if="!media">
          <span class="modal__cross" />
          閉じる
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    content: {
      required: false,
      default: null,
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    hideModal() {
      this.$emit('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';
@import '../../_sass/mixins';
@import '../../_sass/modal';

.modal {
  &__overlay {
    @extend %overlay;
  }
  &__wrapper {
    @extend %wrapper;
    width: 800px;
    max-width: 80%;
    &--sp {
      width: 87.5%;
    }
  }
  &__content {
    background: #f9f9f9;
    height: 100%;
    max-height: 80vh;
    padding: 44px 29px;
    border: solid 1px #a1a1a1;
    box-sizing: border-box;
    box-shadow: 4px 4px 1px 0px rgba(35, 24, 21, 0.2);
    overflow: auto;
    &--sp {
      padding: 9px 16px 29px;
    }
  }
  &__image {
    width: 100%;
  }
  &__close {
    width: 66px;
    margin: 50px auto 0;
    outline: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &--upper {
      width: 15px;
      height: 15px;
      justify-content: center;
      position: absolute;
      top: -30px;
      right: 0;
    }
  }
  &__cross {
    @extend %cross;
    &--white {
      @extend %cross;
      width: 100%;
      height: 100%;
      display: block;
      &::before,
      &::after {
        border-color: #fff;
      }
    }
  }
}
</style>
